import { patientApi } from '@/api/PatientApi'
import { useQuery } from '@tanstack/react-query'

export const PENDING_FORMS_QUERY_KEY = ['pending-forms']

/**
 * The signed-in patient's unsubmitted forms.
 *
 * Refetched on focus so a form finished in another tab, or one a studio just issued, shows
 * up on returning to the home screen without a restart.
 */
const useFetchPendingForms = () => {
	const {
		data = [],
		isLoading,
		isError,
	} = useQuery({
		queryKey: PENDING_FORMS_QUERY_KEY,
		queryFn: () => patientApi.getPendingForms(),
		staleTime: 30000,
		refetchOnWindowFocus: true,
	})

	return {
		pendingForms: data,
		isLoading,
		isError,
	}
}

export { useFetchPendingForms }
